import React from 'react';
import styled, { keyframes } from 'styled-components';

const floatAnimation = keyframes`
  0% { transform: translateY(0) rotate(0deg); opacity: 0; }
  20% { opacity: 0.8; }
  100% { transform: translateY(-1000px) rotate(720deg); opacity: 0; }
`;

const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
`;

const HeartPattern = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 50% 50%, ${props => props.theme.colors.primary}10 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, ${props => props.theme.colors.primary}10 0%, transparent 30%),
    radial-gradient(circle at 20% 80%, ${props => props.theme.colors.primary}10 0%, transparent 30%);
  opacity: 0.4;
`;

const FloatingHeart = styled.div`
  position: absolute;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background: ${props => props.theme.colors.primary};
  opacity: 0;
  animation: ${floatAnimation} ${props => props.duration}s linear infinite;
  animation-delay: ${props => props.delay}s;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: inherit;
    border-radius: 50%;
  }
  
  &::before {
    left: -50%;
  }
  
  &::after {
    top: -50%;
  }
  
  transform: rotate(45deg);
  transform-origin: center;
  filter: blur(2px);
`;

const CenterHeart = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  opacity: 0.1;
  animation: ${pulseAnimation} 4s ease-in-out infinite;
  
  svg {
    width: 100%;
    height: 100%;
    fill: ${props => props.theme.colors.primary};
  }
`;

const generateHearts = (count) => {
  return Array.from({ length: count }, (_, i) => ({
    size: Math.random() * 20 + 10,
    left: Math.random() * 100,
    duration: Math.random() * 15 + 15,
    delay: Math.random() * 20
  }));
};

const BackgroundDesign = () => {
  const hearts = generateHearts(20);

  return (
    <Container>
      <HeartPattern />
      {hearts.map((heart, index) => (
        <FloatingHeart
          key={index}
          size={heart.size}
          style={{ left: `${heart.left}%`, bottom: '-100px' }}
          duration={heart.duration}
          delay={heart.delay}
        />
      ))}
      <CenterHeart>
        <svg viewBox="0 0 24 24">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
      </CenterHeart>
    </Container>
  );
};

export default BackgroundDesign;
